import "pixi-spine";
import "pixi.js";
import { BF2DoghouseDog } from "../../graphics/outskirts/BF2DoghouseDog";
var Application = PIXI.Application;
var DogTreatCanvas = /** @class */ (function () {
    function DogTreatCanvas() {
    }
    DogTreatCanvas.prototype.getDog = function () {
        return this.dog;
    };
    DogTreatCanvas.prototype.start = function () {
        var Options = {
            antialias: false,
            autoResize: false,
            autoStart: false,
            backgroundColor: 0xa7ca4d,
            height: 344,
            powerPreference: "high-performance",
            preserveDrawingBuffer: false,
            roundPixels: false,
            view: document.getElementById("dog-treat-canvas"),
            width: 386,
        };
        this.app = new Application(Options);
        this.app.start();
        if (this.app.stage.children.length > 0) {
            this.app.stage.children.forEach(function (child) { return child.destroy(true); });
        }
        // Add Background
        var background = PIXI.Texture.fromImage(require("../../assets/doghouse/DogBgGfx.png"));
        var backgroundSprite = new PIXI.Sprite(background);
        this.app.stage.addChild(backgroundSprite);
        // Add dog animation
        this.dog = new BF2DoghouseDog();
        this.dog.setup({ scale: 0.5 });
        this.dog.position.set(175, 430);
        this.app.stage.addChild(this.dog);
    };
    DogTreatCanvas.prototype.destroy = function () {
        this.app.stop();
        this.app.destroy();
    };
    return DogTreatCanvas;
}());
export { DogTreatCanvas };
export var dogTreatCanvas = new DogTreatCanvas();



//////////////////
// WEBPACK FOOTER
// ./src/features/doghouse/DogTreatCanvas.ts
// module id = 2627
// module chunks = 3